import React from "react";

const DecrementIcon = () => {
  return (
    <svg
      width="8"
      height="6"
      viewBox="0 0 8 6"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.327 0C.217 0-.173.74.452 1.645L2.867 5.15c.626.907 1.644.904 2.267 0L7.55 1.644C8.176.735 7.785 0 6.674 0H1.327z"
        fill="#A3D9CB"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default DecrementIcon;
